function A(t) {
  return t === !0 || t === 1 || t === "1" || t === "yes" ? !0 : t === !1 || t === 0 || t === "0" || t === "no" ? !1 : null;
}
function R(t) {
  return A(t.navigator.globalPrivacyControl);
}
function G(t) {
  const e = t.navigator;
  return A(
    e.doNotTrack ?? e.msDoNotTrack ?? t.doNotTrack
  );
}
function M(t) {
  return A(t);
}
let I = 0;
function y(t) {
  return I += 1, `${t}_${Date.now()}_${I}`;
}
function L(t, e) {
  let n = e;
  for (; ; ) {
    try {
      if (n.frames[t]) return n;
    } catch {
    }
    const r = n.parent;
    if (n === n.top || r === n) return null;
    n = r;
  }
}
const T = {
  status: "unavailable",
  gppString: "",
  applicableSections: [],
  supportedApis: [],
  parsedSections: {},
  signalStatus: null,
  cmpStatus: null,
  listenerId: null
};
function b(t) {
  return typeof t == "string" ? t : null;
}
function N(t) {
  return typeof t == "number" && Number.isInteger(t) ? t : null;
}
function D(t) {
  return Array.isArray(t) ? t.filter(
    (e) => typeof e == "number" && Number.isInteger(e) && e > 0
  ) : [];
}
function x(t) {
  return Array.isArray(t) ? t.filter((e) => typeof e == "string") : [];
}
function F(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) ? { ...t } : {};
}
function j(t) {
  const e = t.pingData;
  if (!e) return null;
  const n = b(e.signalStatus), r = b(e.cmpStatus);
  return {
    status: n === "ready" && r === "loaded" ? "ready" : "pending",
    gppString: b(e.gppString) ?? "",
    applicableSections: D(e.applicableSections),
    supportedApis: x(e.supportedAPIs),
    parsedSections: F(e.parsedSections),
    signalStatus: n,
    cmpStatus: r,
    listenerId: N(t.listenerId)
  };
}
function $(t, e) {
  const n = typeof t.__gpp == "function" ? t.__gpp : null, r = n ? null : L("__gppLocator", t);
  if (!n && !r)
    return { available: !1, ready: Promise.resolve(), destroy() {
    } };
  let s = !1, o = null, i = () => {
  }, c = !1;
  const g = new Promise((p) => {
    i = p;
  });
  function h(p, l = !0) {
    if (s || !l || !p || typeof p == "boolean") return;
    const a = j(p);
    a && (o = a.listenerId ?? o, e(a), !c && a.status === "ready" && (c = !0, i()));
  }
  let d = null;
  try {
    if (n)
      n("addEventListener", h);
    else if (r) {
      const p = y("gpp"), l = (a) => {
        if (a.source !== r) return;
        const f = a.data?.__gppReturn;
        f?.callId === p && h(f.returnValue ?? null, f.success !== !1);
      };
      t.addEventListener("message", l), d = () => t.removeEventListener("message", l), r.postMessage(
        { __gppCall: { command: "addEventListener", version: "1.1", callId: p } },
        "*"
      );
    }
  } catch {
    e({ ...T, status: "error" }), i();
  }
  return {
    available: !0,
    ready: g,
    destroy() {
      if (!s && (s = !0, d?.(), o !== null))
        try {
          n ? n("removeEventListener", () => {
          }, o) : r && r.postMessage(
            {
              __gppCall: {
                command: "removeEventListener",
                version: "1.1",
                callId: y("gpp_remove"),
                parameter: o
              }
            },
            "*"
          );
        } catch {
        }
    }
  };
}
function O(t, e) {
  return { ...t, status: e };
}
const U = /* @__PURE__ */ new Set(["tcloaded", "useractioncomplete"]), k = {
  status: "unavailable",
  tcString: "",
  gdprApplies: null,
  eventStatus: null,
  cmpStatus: null,
  listenerId: null,
  vendorConsent: null,
  purposeOneConsent: null,
  purposeOneTreatment: null,
  publisherRestriction: null
};
function _(t) {
  return typeof t == "boolean" ? t : null;
}
function S(t) {
  return typeof t == "string" ? t : null;
}
function J(t) {
  return typeof t == "number" && Number.isInteger(t) ? t : null;
}
function C(t, e) {
  return t ? _(t[e] ?? t[String(e)]) : null;
}
function V(t, e) {
  if (e === void 0) return null;
  const n = t.publisher?.restrictions?.[1] ?? t.publisher?.restrictions?.["1"], r = n?.[e] ?? n?.[String(e)];
  return r === 0 || r === 1 || r === 2 ? r : null;
}
function z(t, e) {
  const n = _(t.gdprApplies), r = S(t.eventStatus);
  return {
    status: n === !1 || r !== null && U.has(r) ? "ready" : "pending",
    tcString: S(t.tcString) ?? "",
    gdprApplies: n,
    eventStatus: r,
    cmpStatus: S(t.cmpStatus),
    listenerId: J(t.listenerId),
    vendorConsent: e === void 0 ? null : C(t.vendor?.consents, e) === !0,
    purposeOneConsent: C(t.purpose?.consents, 1),
    purposeOneTreatment: _(t.purposeOneTreatment),
    publisherRestriction: V(t, e)
  };
}
function Y(t, e, n) {
  const r = typeof t.__tcfapi == "function" ? t.__tcfapi : null, s = r ? null : L("__tcfapiLocator", t);
  if (!r && !s)
    return { available: !1, ready: Promise.resolve(), destroy() {
    } };
  let o = !1, i = null, c = () => {
  }, g = !1;
  const h = new Promise((l) => {
    c = l;
  });
  function d(l, a) {
    if (o || !a || !l || typeof l == "boolean") return;
    const f = z(l, e);
    i = f.listenerId ?? i, n(f), !g && f.status === "ready" && (g = !0, c());
  }
  let p = null;
  try {
    if (r)
      r("addEventListener", 2, d);
    else if (s) {
      const l = y("tcf"), a = (f) => {
        if (f.source !== s) return;
        const m = f.data?.__tcfapiReturn;
        m?.callId === l && d(m.returnValue ?? null, m.success === !0);
      };
      t.addEventListener("message", a), p = () => t.removeEventListener("message", a), s.postMessage(
        { __tcfapiCall: { command: "addEventListener", version: 2, callId: l } },
        "*"
      );
    }
  } catch {
    n({ ...k, status: "error" }), c();
  }
  return {
    available: !0,
    ready: h,
    destroy() {
      if (!o && (o = !0, p?.(), i !== null))
        try {
          r ? r("removeEventListener", 2, () => {
          }, i) : s && s.postMessage(
            {
              __tcfapiCall: {
                command: "removeEventListener",
                version: 2,
                callId: y("tcf_remove"),
                parameter: i
              }
            },
            "*"
          );
        } catch {
        }
    }
  };
}
function E(t, e) {
  return { ...t, status: e };
}
const q = [
  // Deprecated USPV1 compatibility when an older CMP includes section 6 in GPP.
  "OptOutSale",
  "SaleOptOut",
  "SharingOptOut",
  "TargetedAdvertisingOptOut"
];
function P(t) {
  const e = new Set(t.applicableSections.filter((r) => r > 0)), n = new Set(
    t.supportedApis.map((r) => r.split(":", 2)).filter(([r]) => e.has(Number(r))).map(([, r]) => r).filter((r) => !!r)
  );
  return Object.entries(t.parsedSections).filter(([r]) => n.has(r)).map(([, r]) => r).filter(
    (r) => r !== null && typeof r == "object" && !Array.isArray(r)
  );
}
function B(t) {
  return P(t).some((e) => e.Gpc === !0 ? !0 : q.some((n) => e[n] === 1));
}
function u(t, e, n, r) {
  for (const s of r)
    e[s] = !1, t[s].push(n);
}
function W(t) {
  const e = {
    trackCookie: !0,
    useAdIdentity: !0,
    useFineGeo: !0
  }, n = {
    trackCookie: [],
    useAdIdentity: [],
    useFineGeo: []
  }, r = [
    "trackCookie",
    "useAdIdentity",
    "useFineGeo"
  ];
  return t.gpc === !0 && u(n, e, "gpc", r), t.dnt === !0 && u(n, e, "dnt", r), t.lmt === !0 && u(n, e, "lmt", r), (t.gdprApplies === !0 || t.tcf.gdprApplies === !0) && (t.tcf.status === "unavailable" ? u(n, e, "gdpr-without-cmp", r) : t.tcf.status !== "ready" ? u(n, e, "tcf-not-ready", r) : t.tcf.vendorConsent === null ? u(n, e, "tcf-vendor-unconfigured", r) : (t.tcf.vendorConsent !== !0 && u(n, e, "tcf-vendor-denied", r), t.tcf.purposeOneConsent !== !0 && u(n, e, "tcf-purpose-one-denied", r), t.tcf.purposeOneTreatment === !0 && u(n, e, "tcf-purpose-one-treatment", r), t.tcf.publisherRestriction !== null && t.tcf.publisherRestriction !== 1 && u(n, e, "tcf-publisher-restricted", r))), t.gpp.applicableSections.filter((i) => i > 0).length > 0 && (t.gpp.status !== "ready" || P(t.gpp).length === 0 ? u(n, e, "gpp-not-readable", r) : B(t.gpp) && u(n, e, "gpp-opt-out", r)), { capabilities: e, reasons: n };
}
const H = 2e3;
function v(t) {
  return JSON.parse(JSON.stringify(t));
}
function w(t) {
  const e = W(t);
  return {
    version: 1,
    signals: t,
    capabilities: e.capabilities,
    reasons: e.reasons
  };
}
class K {
  constructor(e, n) {
    this.options = e, this.win = n, this.callbacks = /* @__PURE__ */ new Set(), this.collectors = [], this.destroyed = !1, this.initialReady = Promise.resolve();
    const r = e.initialSnapshot?.signals, s = R(n), o = G(n), i = M(e.lmt), c = {
      tcf: r?.tcf ? v(r.tcf) : { ...k },
      gpp: r?.gpp ? v(r.gpp) : { ...T },
      gpc: s ?? r?.gpc ?? null,
      dnt: o ?? r?.dnt ?? null,
      lmt: i ?? r?.lmt ?? null,
      gdprApplies: e.gdprApplies ?? r?.gdprApplies ?? null
    };
    this.current = w(c), this.startCollectors();
  }
  async ready() {
    await this.initialReady;
  }
  canTrackCookie() {
    return this.current.capabilities.trackCookie;
  }
  canUseAdIdentity() {
    return this.current.capabilities.useAdIdentity;
  }
  canUseFineGeo() {
    return this.current.capabilities.useFineGeo;
  }
  snapshot() {
    return v(this.current);
  }
  onChange(e) {
    return this.destroyed ? () => {
    } : (this.callbacks.add(e), () => this.callbacks.delete(e));
  }
  destroy() {
    if (!this.destroyed) {
      this.destroyed = !0;
      for (const e of this.collectors) e.destroy();
      this.collectors.length = 0, this.callbacks.clear();
    }
  }
  startCollectors() {
    const e = Y(this.win, this.options.tcfVendorId, (i) => {
      this.updateSignals({ tcf: i });
    }), n = $(this.win, (i) => {
      this.updateSignals({ gpp: i });
    });
    this.collectors.push(e, n);
    const r = {};
    e.available && this.current.signals.tcf.status === "unavailable" && (r.tcf = E(this.current.signals.tcf, "pending")), n.available && this.current.signals.gpp.status === "unavailable" && (r.gpp = O(this.current.signals.gpp, "pending")), this.updateSignals(r);
    const s = [e, n].filter((i) => i.available);
    if (s.length === 0) return;
    const o = Math.max(0, this.options.timeoutMs ?? H);
    this.initialReady = Promise.race([
      Promise.all(s.map((i) => i.ready)).then(() => {
      }),
      new Promise((i) => {
        this.win.setTimeout(() => {
          const c = {};
          this.current.signals.tcf.status === "pending" && (c.tcf = E(this.current.signals.tcf, "timeout")), this.current.signals.gpp.status === "pending" && (c.gpp = O(this.current.signals.gpp, "timeout")), this.updateSignals(c), i();
        }, o);
      })
    ]);
  }
  updateSignals(e) {
    if (this.destroyed || Object.keys(e).length === 0) return;
    const n = w({ ...this.current.signals, ...e });
    if (JSON.stringify(n) !== JSON.stringify(this.current)) {
      this.current = n;
      for (const r of this.callbacks)
        try {
          r(this.snapshot());
        } catch (s) {
          console.error("@neuronic/privacy onChange callback failed", s);
        }
    }
  }
}
async function Q(t = {}) {
  if (typeof window > "u")
    throw new Error("@neuronic/privacy requires a browser window");
  const e = new K(t, window);
  return await e.ready(), e;
}
export {
  Q as resolvePrivacy
};
//# sourceMappingURL=privacy.es.js.map
